import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles'

const OnlineProfileList = ({ children }) => <ul className={styles.list}>{children}</ul>

OnlineProfileList.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default OnlineProfileList
